<script setup>
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";

const model = defineModel({type: Number, required: true});

const {disabled = false} = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

// Carbon ISO weekday: 1 = Monday, 2 = Tuesday, ...
const dayOptions = [
  {label: 'Mon', value: 1},
  {label: 'Tue', value: 2},
  {label: 'Wed', value: 3},
  {label: 'Thu', value: 4},
  {label: 'Fri', value: 5},
];
</script>

<template>
  <div class="tw-flex tw-justify-between tw-items-center tw-rounded-lg tw-border tw-border-neutral-300 tw-p-6">
    <div>
      <p class="tw-font-semibold tw-text-neutral-900 tw-text-base">
        When should we send your updates?
      </p>
      <p class="tw-text-neutral-600 tw-text-sm">
        Pick the day you'd like to receive your email summary
      </p>
    </div>

    <TabContainer class="tw-grid tw-grid-cols-5 tw-gap-2">
      <TabItem
        v-for="day in dayOptions"
        :key="day.value"
        :active="model === day.value"
        :class="[
          'tw-justify-center',
          {
            'tw-pointer-events-none': disabled,
          }
        ]"
        class="tw-justify-center"
        @click="model = day.value"
      >
        <span>{{ day.label }}</span>
      </TabItem>
    </TabContainer>
  </div>
</template>
